export default __webpack_public_path__ + "static/planner-bg-c82c5d4930368373294c9fcb3993c9ab.png";